<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">Editar Programa de Verificación</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{form.value.IdEstadoPv | IconoEstadoPv }}" ngbTooltip="{{form.value.EstadoPv}}" />
                
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header">
                    </div>
                    <div class="card-body-detalle">                        
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpCampania">Campaña</label>
                                <input formControlName="Campania" readonly name="Campania" title="" class="form-control" inputStyleClass="form-control" type="text" value="">
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpPeriodo">Periodo</label>
                                <input formControlName="Periodo" readonly name="Periodo" title="" class="form-control" inputStyleClass="form-control" type="text" value="">
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpCampania">Comunidad Autónoma</label>
                                <input formControlName="ComunidadAutonoma" readonly name="ComunidadAutonoma" title="" class="form-control" inputStyleClass="form-control" type="text" value="">
                            </div>
                        </div>
                        <!--Fechas-->
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpFecha">Fecha Presentación</label>
                                <input formControlName="FechaPresentacion" readonly name="FechaPresentacion" title="" class="form-control" value="">
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpFecha">Fecha Devolución</label>
                                <input formControlName="FechaDevolucion" readonly name="FechaDevolucion" title="" class="form-control" value="">
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpFecha">Fecha Admisión</label>
                                <input formControlName="FechaAdmision" readonly name="FechaAdmision" title="" class="form-control" value="">
                            </div>
                        </div>
                        <!--OBSERVACIONES-->
                        <div class="row group-filtros">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirObservaciones}" for="inpCodigo">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" [ngClass]="displayFieldCss('Observaciones')"
                                          maxlength="5000" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                          value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Observaciones','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>
                        <!--Documento-->
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpTexto">Descripción Documento</label>
                                <input formControlName="Texto" name="Texto" title="" class="form-control" inputStyleClass="form-control"
                                       [ngClass]="displayFieldCss('Texto')" id="inpTexto" type="text" value="" maxlength="200">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Texto','required')">
                                    Descripción Documento es obligatoria
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar"
                                                       [required]="true" [documentModule]="documentModuleCampania"
                                                       [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit"
                                                       (fileUploaded)="onFileUploaded($event)" (fileDeleted)="onFileDeleted($event)">
                                </app-document-uploader>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    </form>
</div>

